// extracted by mini-css-extract-plugin
export default {"Login":"styles_Login__HPs1N","LoginContent":"styles_LoginContent__iP0xJ","logoBlock":"styles_logoBlock__8BL3W","title":"styles_title__Nvr8k"};